var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('go-top',{attrs:{"bottom":15}}),_c('Navbar'),_c('Header'),_c('Timer'),_c('Hackathon-List'),_c('FAQ'),_c('Sponsor'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }